/*
 * ItemCombobox.tsx - Eine Entity (zB ItemNo) aus der Suche auswählen
 *
 * Created by Dr. Maximillian Dornseif 2022-02-10 in huWaWi3 25.2.0
 * Copyright (c) 2022  Dr. Maximillian Dornseif
 */

import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import gql from 'graphql-tag';
// import parse from 'autosuggest-highlight/parse'
import React, { useState } from 'react';
import { useQuery } from 'urql';

import { fuzzaldrinHighlight, fuzzaldrinSort } from '../../lib/util/fuzzaldrin-react';

const MIN_INPUT_LENGTH = 3;
export interface IEntitySelectComboboxSearchProps {
  schemaNames: string[];
  name?: string;
  placeholder?: string;
  onChanged?: (str) => void;
  label?: string;
  variant?;
  error?: boolean;
  helperText?: string;
  onChange?;
  onBlur?;
  disabled?: boolean;
}

export function EntitySelectComboboxSearch(props: IEntitySelectComboboxSearchProps) {
  const [inputValue, setInputValue] = useState('');
  const [result] = useQuery({
    query: SEARCH_QUERY,
    variables: { term: inputValue, schemata: props.schemaNames },
    pause: !inputValue || inputValue.length < MIN_INPUT_LENGTH,
  });
  const { data, fetching } = result;
  const options = fuzzaldrinSort(inputValue, data?.search || []);
  // see https://mui.com/api/autocomplete/
  return (
    <Autocomplete
      sx={{ width: '25em' }}
      isOptionEqualToValue={(option, v) => option?.designator === v.designator}
      getOptionLabel={(option) => option?.title}
      filterOptions={(x) => x} // filtering disabled
      options={options}
      loading={fetching}
      disabled={!!props.disabled}
      // loadingText
      autoComplete
      autoHighlight
      autoSelect
      ListboxComponent={List}
      // ListboxProps={{ dense: true } as any}
      noOptionsText={
        inputValue.length < MIN_INPUT_LENGTH
          ? 'bitte mindestens 3 Zeichen eingeben'
          : '(noch) keine Ergebnisse'
      }
      onChange={(event: any, newValue: any) => {
        if (props?.onChanged) {
          props?.onChanged(newValue.designator);
        }
        // To use the Event in react-hook-form name has to be set as expected by react-hook-form
        event.target.name = props.name;
        // We also have to make sure, that `designator` and not `title` is sent upstream.
        event.target.value = newValue.designator;
        if (props?.onChange) {
          props?.onChange(event);
        }
      }}
      // onBlur={(event: any) => {
      //   // To use the Event in react-hook-form name has to be set as expected by react-hook-form
      //   event.target.name = props.name
      //   event.target.type = 'input'
      //   // We also have to make sure, that `designator` and not `title` is sent upstream.
      //   event.target.value = event.target.value.split(' ')?.[0]
      //   console.log(event.target.value)
      //   if (props?.onChange) {
      //     props?.onBlur(event)
      //   }
      // }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          variant="standard"
          error={props.error}
          helperText={props.helperText}
          {...params}
          label={props.label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {fetching ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      renderOption={(props, option, state) => {
        // const matches = option.structured_formatting.main_text_matched_substrings
        // const parts = parse(
        //   option.structured_formatting.main_text,
        //   matches.map((match: any) => [match.offset, match.offset + match.length])
        // )
        return (
          <ListItem key={`${option.designator}`} {...props}>
            <ListItemText
              sx={{ textDecoration: option.istAktiv === false ? 'line-through' : 'none' }}
              primary={fuzzaldrinHighlight(option.title, inputValue)}
            />
          </ListItem>
        );
      }}
    />
  );
}

const SEARCH_QUERY = gql`
  query FulltextSearchSchemaQuery($term: String!, $schemata: [String]) {
    search(term: $term, schemata: $schemata) {
      designator
      id
      istAktiv
      matches
      title
      url
      schema
    }
  }
`;
